import { getMaxListeners } from 'node-notifier';
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        routeData:'',
        isMNR:false
    },

    getters:{
        getRoute(state){
            if(!state.routeData) {
              try {
                let routeData = localStorage.getItem("menuList");
                state.routeData = JSON.parse(routeData)
              } catch (err) {
                console.warn(err)
              }
            }
            return state.routeData
        },
        getMaxListeners(state){
            return state.isMNR
        }
    },
    actions:{
        set(context,routedata){
            context.commit("setRoute",routedata);
        },
        setMNR(context,isMNR){
            context.commit("setMNRBool",isMNR);
        }
    },

    mutations:{
        setRoute(state,routedata){
            state.routeData = routedata;
            localStorage.setItem("menuList",JSON.stringify(routedata));
        },
        setMNRBool(state,isMNR){
            state.isMNR=isMNR;
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js